"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configuration_store_utils_1 = require("./configuration-store/configuration-store-utils");
const interfaces_1 = require("./interfaces");
// Requests AND stores precomputed flags, reuses the configuration store
class PrecomputedFlagRequestor {
    constructor(httpClient, precomputedFlagStore, subjectKey, subjectAttributes, precomputedBanditsStore, banditActions) {
        this.httpClient = httpClient;
        this.precomputedFlagStore = precomputedFlagStore;
        this.subjectKey = subjectKey;
        this.subjectAttributes = subjectAttributes;
        this.precomputedBanditsStore = precomputedBanditsStore;
        this.banditActions = banditActions;
    }
    async fetchAndStorePrecomputedFlags() {
        const precomputedResponse = await this.httpClient.getPrecomputedFlags({
            subject_key: this.subjectKey,
            subject_attributes: this.subjectAttributes,
            bandit_actions: this.banditActions,
        });
        if (!precomputedResponse) {
            return;
        }
        const promises = [];
        promises.push((0, configuration_store_utils_1.hydrateConfigurationStore)(this.precomputedFlagStore, {
            entries: precomputedResponse.flags,
            environment: precomputedResponse.environment ?? { name: interfaces_1.UNKNOWN_ENVIRONMENT_NAME },
            createdAt: precomputedResponse.createdAt,
            format: precomputedResponse.format,
            salt: precomputedResponse.salt,
        }));
        if (this.precomputedBanditsStore) {
            promises.push((0, configuration_store_utils_1.hydrateConfigurationStore)(this.precomputedBanditsStore, {
                entries: precomputedResponse.bandits,
                environment: precomputedResponse.environment ?? { name: interfaces_1.UNKNOWN_ENVIRONMENT_NAME },
                createdAt: precomputedResponse.createdAt,
                format: precomputedResponse.format,
                salt: precomputedResponse.salt,
            }));
        }
        await Promise.all(promises);
    }
}
exports.default = PrecomputedFlagRequestor;
//# sourceMappingURL=precomputed-requestor.js.map